import { AdministrationEndpoints } from "@app/shared/data-access/src/lib/administration/types/administration-endpoints";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormFieldParams,
  IHardTable,
} from "@app/shared/ui-lib/src/lib";
import { IBaseConfig, IFormFieldFilter } from "@models/form/base-config";
import { IAppUser } from "@models/user-management/user";
import { AppUserSupervisorModalComponent } from "@modules/admin/modules/dictionary-modules/app-users/app-user-supervisor-modal/app-user-supervisor-modal.component";

export class AppUserConfig implements IBaseConfig {
  version = 1;
  dicType = AdministrationEndpoints.AppUser;
  hideAddBtn = true;
  title = "dicitionary.appUsers";
  isCrudByModal = true;
  editModalComponent = AppUserSupervisorModalComponent;

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: IHardTable<IAppUser[]> = {
    showDefaultActions: true,
    hideDeleteBtn: true,
    tableColumns: "44px repeat(8, auto) 60px",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.badgeNumber",
        name: "badgeNo",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.fullName",
        name: "fullName",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.email",
        name: "email",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.jobTitle",
        name: "jobTitle",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.department",
        name: "department",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.userType",
        name: "userTypeTemplate",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.supervisor",
        name: "fullName",
        type: HardTableColumnTypeEnum.Parent,
        parent: "supervisorShortModel",
      },
      {
        title: "dicTable.pswsSupervisor",
        name: "fullName",
        type: HardTableColumnTypeEnum.Parent,
        parent: "pswsSupervisorShortModel",
      },
    ],
    dataCallback: this.dataCallback,
  };

  dataCallback(data: IAppUser[]) {
    return data.map((item) => ({
      ...item,
      userTypeTemplate: item?.isActive
        ? "dicTable.userActive"
        : "dicTable.userInactive",
    }));
  }
}
